import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import storageSession from "redux-persist/es/storage/session";
import { persistReducer } from "redux-persist";
import { RootState } from "../../../app/store";
import { SelectedDeliveryOption } from "../../../app/models/features/deliveryOptions/selectedDeliveryOption";
import { TariffTypeEnum } from "../../../app/enums/tariffTypeEnum";

const initialState: SelectedDeliveryOption = {
    deliveryDate: null,
    loadingDate: null,
    optionType: TariffTypeEnum.Standard,
    totalAmountWithSurcharges: 0
};

const slice = createSlice({
    name: "deliveryOptionSlice",
    initialState,
    reducers: {
        setDeliveryOption: (state, { payload }: PayloadAction<SelectedDeliveryOption>) => {
            state.deliveryDate = payload.deliveryDate;
            state.loadingDate = payload.loadingDate;
            state.optionType = payload.optionType;
            state.totalAmountWithSurcharges = Math.round(payload.totalAmountWithSurcharges * 100) / 100;
        },
        setDeliveryOptionDate: (state, { payload }: PayloadAction<string>) => {
            state.deliveryDate = payload;
        },
        setLoadingOptionDate: (state, { payload }: PayloadAction<string>) => {
            state.loadingDate = payload;
        },
        setDeliveryOptionInitialState: () => initialState,
    },
});

export const { setDeliveryOption, setDeliveryOptionInitialState, setDeliveryOptionDate, setLoadingOptionDate } = slice.actions;

export default slice.reducer;

const deliveryOptionPersistConfig = {
    key: "deliveryOption",
    storage: storageSession,
};

export const deliveryOptionPersistedReducer = persistReducer(deliveryOptionPersistConfig, slice.reducer);

export const selectDeliveryOption = (state: RootState) => state.deliveryOption;
